import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';

//import components
import ItemText from './ItemText.js';

const ItemListSeparate = ({ clang, list, types }) => {
    return (
        <div>
            {types &&
                types.map((listItem, index) =>
                    <div key={index} className="item__separate__item">
                        <ItemText text={listItem.label}/>
                    </div>)}
            {list.map((listItem, index) =>
                <div key={index} className="item__separate__item">
                    {typeof listItem === 'string' &&
                        <ItemText text={listItem}/>}
                    {typeof listItem !== 'string' &&
                        <ItemText text={listItem.label} link={listItem.link} type={listItem.entityType} isTransit={listItem.transliterated}/>}
                    {index !== list.length - 1 && <span>,</span>}
                </div>)}
        </div>
    );
};

ItemListSeparate.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemListSeparate);



// WEBPACK FOOTER //
// ./src/components/items/ItemListSeparate.js